import { render, staticRenderFns } from "./displayinfo.vue?vue&type=template&id=7efb4e63&scoped=true"
import script from "./displayinfo.vue?vue&type=script&lang=js"
export * from "./displayinfo.vue?vue&type=script&lang=js"
import style0 from "./displayinfo.vue?vue&type=style&index=0&id=7efb4e63&prod&lang=css"
import style1 from "./displayinfo.vue?vue&type=style&index=1&id=7efb4e63&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efb4e63",
  null
  
)

export default component.exports